import dayjs from 'dayjs'
import Header from 'pages/Overview/components/OverviewChart/Header'
import React, { useState, useEffect, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { apiRequest } from 'store/Misc/apiRequest'
import useSWR from 'swr'
import Chart from './Chart'
import LineChart from './LineChart'

export default withTranslation()(function Monitoring({ t }) {
  const [startDate, setStartDate] = useState(dayjs().subtract(1, 'week').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'))
  // const [lineChartData, setLineChartData] = useState({})
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // var month = ["January", "February", "March", "April", "May", "June", "July",
    // "August", "September", "October", "November", "December"];
  const shortmonth = React.useMemo(() => ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], []);

  const getRangeData = (data = []) => {
    setStartDate(data[0])
    setEndDate(data[1])
  }
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (window.location.href.includes('=') && window.location.href.includes('?') && +urlParams.get('id') > 1) { } else { window.location.assign('/promo/campaign') }
  }, [])

  const { data } = useSWR(`promos/campaigns/${+urlParams.get('id')}`)

  const add_0 = useCallback(
    (aDD_0) => aDD_0.toString().length > 1 ? aDD_0 : '0' + aDD_0,
    []
  );
  const format = useCallback(
    date => `${new Date(date).getFullYear()}-${add_0(new Date(date).getMonth() + 1)}-${add_0(new Date(date).getDate())}`,
    [add_0]
  );
  const payload = React.useMemo(() => ({
    promo_campaign_id: 1,
    start_date: format(startDate),
    end_date: format(endDate)
  }), [startDate, endDate, format]);

  const [viewData, setViewData] = useState([])
  // [20, 18, 10, 28, 23, 12, 25]
  const [daysData, setDaysData] = useState([])
  // ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  const getAllViewedDays = useCallback((getData) => {
    setDaysData([]); setViewData([]);
    for (const day in getData.views) {
      if (Object.hasOwnProperty.call(getData.views, day)) {
        const views = getData.views[day];
        setViewData(prevViewData => [...prevViewData, views])
        setDaysData(prevDaysData => [...prevDaysData, `${shortmonth[day.substring(5, 7)-1]} ${day.substring(8, 10)}`])
      }
    }
  }, [shortmonth])

  const getLineChartByDay = useCallback(async () => {
    await apiRequest({
      method: 'post',
      url: '/promos/campaigns/views-by-date-range',
      payload: payload
    }).then(res => getAllViewedDays(res.data))
      .catch(err => console.log(err))
  }, [payload, getAllViewedDays])

  useEffect(() => {
    getLineChartByDay()
    // getAllViewedDays()
  }, [startDate, endDate, getLineChartByDay])


  return (
    <div className="md:grid md:grid-cols-2 gap-8 w-full p-0 m-0 bg-light">
      <div className="w-full h-[600px] rounded-lg border p-3 relative">
        <div className={'text-[#44C4A1] absolute z-50 w-[100px] text-center flex flex-col justify-center '} style={{ top: '40%', left: '42%', fontSize: '14px' }}>
          <div className='w-[7px] h-[7px] rounded-[100%] bg-[#44C4A1] mx-auto'></div> <div> {data?.data.impressions} </div> <p>impressions</p>
        </div>
        <label className="text-xl font-bold text-dark">{t('promo.monitoring.views')}</label>
        <Chart
          data={[
            { name: t('promo.form.impression'), value: data?.data.impressions || '...' },
            { name: t('promo.views'), value: data?.data.views_count },
          ]}
          colors={['#44C4A1', '#1976D2']}
        ></Chart>
        <div className='flex justify-between w-3/4 m-auto'>

          <div className='flex gap-3 items-center'>
            <div className='rounded-full p-2 bg-[#1976D2] w-[15px] h-[15px]'></div>
            Total {t('promo.views')}
          </div>
          <div className='flex gap-3 items-center'>
            <div className='rounded-full p-2 bg-[#44C4A1] w-[15px] h-[15px]'></div>
            Total  {t('promo.form.impression')}
          </div>
        </div>
      </div>

      <div className="w-full h-[600px] rounded-lg border p-3 relative">
        <div className={'text-[violet] absolute z-50 w-[100px] text-center flex flex-col justify-center '} style={{ top: '40%', left: '42%', fontSize: '14px' }}>
          <div className='w-[7px] h-[7px] rounded-[100%] bg-[violet] mx-auto'></div> <div> {data?.data.clicks_count} </div> <p>Clicks</p>
        </div>
        <label className="text-xl font-bold text-secondary">{t('promo.monitoring.clicks')}</label>

        <Chart
          data={[
            { name: 'Clicks', value: data?.data.clicks_count },
            { name: 'Views', value: data?.data.views_count },
          ]}
          colors={['violet', '#1976D2']}
        />

        <div className='flex justify-between w-3/4 m-auto'>

          <div className='flex gap-1 items-center'>
            <div className='rounded-full p-2 bg-[#1976D2] w-[15px] h-[15px]'></div>
            Total {t('promo.views')}
          </div>
          <div className='flex gap-1 items-center'>
            <div className='rounded-full p-2 bg-[violet] w-[15px] h-[15px]'></div>
            {t('misc.total_clicks')}
          </div>
        </div>
      </div>

      <div className="w-full col-span-2 rounded-lg p-5 bg-dark">

        <div className="h-[600px] w-full">
          {/* <div className='flex justify-between' >
            <div>Week's View</div>
          </div> */}
          <Header getRange={(data) => getRangeData(data)} />

          <LineChart xAxis={{ key: 'Days', data: daysData }} yAxis={{ key: 'Views', data: viewData }} />

          <h5 className="font-medium text-placeholder mt-3 mb-3">{t('misc.total_view')}</h5>
          <h3 className="text-2xl font-semibold">345,535.00</h3>
          <h5 className='text-success'>
            + 7 %
          </h5>

        </div>
      </div>
    </div>
  )
})

